var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4268_37729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.33398H3.33333C1.49533 1.33398 0 2.82932 0 4.66732V11.334C0 13.172 1.49533 14.6673 3.33333 14.6673H12.6667C14.5047 14.6673 16 13.172 16 11.334V4.66732C16 2.82932 14.5047 1.33398 12.6667 1.33398ZM1.33333 5.33398H7.33333V8.66732H1.33333V5.33398ZM8.66667 5.33398H14.6667V8.66732H8.66667V5.33398ZM3.33333 2.66732H12.6667C13.536 2.66732 14.2767 3.22465 14.552 4.00065H1.448C1.72333 3.22465 2.464 2.66732 3.33333 2.66732ZM1.33333 11.334V10.0007H7.33333V13.334H3.33333C2.23067 13.334 1.33333 12.4367 1.33333 11.334ZM12.6667 13.334H8.66667V10.0007H14.6667V11.334C14.6667 12.4367 13.7693 13.334 12.6667 13.334Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4268_37729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.552c200f87d6c08bf9672ba25b5678ea.svg";
export { ForwardRef as ReactComponent };